import PropTypes from 'prop-types';
import { useSnackbar } from 'notistack';
import MaterialTable from 'material-table';
import { Container } from '@material-ui/core';
import React, { useEffect, useState, useRef } from 'react';

import Edit from './Components/Edit.js'
import api from '../../../../services/api.js';
import falha from "../../../../assets/falha.png";
import nivel from "../../../../assets/nivel.png";
import sismo from "../../../../assets/sismo.png";
import vazia from "../../../../assets/vazia.png";
import trinca from "../../../../assets/trinca.png";
import ruptura from "../../../../assets/ruptura.png";
import surgencia from "../../../../assets/vazia.png";
import vazamento from "../../../../assets/vazamento.png";
import galgamento from "../../../../assets/galgamento.png";
import equipamento from "../../../../assets/equipamento.png";
import instrumentacao from "../../../../assets/instrumentacao.png";

export default function MyTable(props) {
    const tableRef = useRef();
    const snack = useRef()
    const { enqueueSnackbar } = useSnackbar();
    snack.current = enqueueSnackbar

    const state = {
        columns: [
            {
                title: "Opções", field: "opcoes",
                render: (rowData) => {
                    return (
                        <Edit setData={props.setData} setOpen={props.setOpen} data={rowData} />
                    )
                }
            },
            {
                title: "Ícone", field: "icon", render: rowData => <img alt="Paeweb" src={rowData.icon} style={{ width: 30 }} />
            },
            { title: "Ocorrência", field: "nome" },
            {
                title: "Descrição", field: "descricao",
                cellStyle: {
                    width: 20,
                    maxWidth: 20
                },
                headerStyle: {
                    width: 20,
                    maxWidth: 20
                }
            },
        ],
    };

    const [values, setValues] = useState([]);

    useEffect(() => {
        async function fetchData() {
            api.get(`/occurrencetype`)
                .then((res) => {
                    let values = []
                    for (let item of res.data) {
                        var icon
                        if (item.nome === 'Vazia') icon = vazia
                        else if (item.nome === 'Trinca') icon = trinca
                        else if (item.nome === 'Equipamento') icon = equipamento
                        else if (item.nome === 'Falha') icon = falha
                        else if (item.nome === 'Galgamento') icon = galgamento
                        else if (item.nome === 'Instrumentação') icon = instrumentacao
                        else if (item.nome === 'Nível') icon = nivel
                        else if (item.nome === 'Ruptura') icon = ruptura
                        else if (item.nome === 'Sismo') icon = sismo
                        else if (item.nome === 'Vazamento') icon = vazamento
                        else if (item.nome === 'Surgência') icon = surgencia
                        let aux = {
                            '_id': item._id,
                            'icon': icon,
                            'nome': item.nome,
                            'descricao': item.descricao,
                            'criado_em': item.criado_em,
                            'criado_por': item.criado_por,
                            'editado_em': item.editado_em,
                            'editado_por': item.editado_por,
                        }
                        values.push(aux)
                    }
                    setValues(values)
                })
                .catch((error) => {
                    console.log(error);
                    snack.current("Falha ao buscar Ocorrências", { variant: 'error' })
                });
        }
        fetchData();
    }, [props.reload]);

    return (
        <Container maxWidth={false} spacing={2}>
            <MaterialTable
                tableRef={tableRef}
                title="Tipos de Ocorrências"
                columns={state.columns}
                data={values}
                options={{
                    search: true,
                    pageSize: 10,
                    exportButton: false,
                    emptyRowsWhenPaging: false,
                    pageSizeOptions: [1, 5, 10, 20],
                    padding: "dense",
                    headerStyle: {
                        textAlign: "center",
                        color: "#b31b1b",
                    },
                    cellStyle: {
                        textAlign: "center",
                        width: '1%',
                    },
                }}

                localization={{
                    body: {
                        emptyDataSourceMessage: "",
                        addTooltip: "adicionar novo",
                        deleteTooltip: "excluir",
                        editRow: { deleteText: "Deseja excluir?" },
                    },

                    header: {
                        actions: "Opções",
                    },

                    toolbar: {
                        searchTooltip: "Pesquisar",
                        searchPlaceholder: "Pesquisar",
                        exportTitle: "exportar",
                        nRowsSelected: "{0} Usuários(s) selecionados",
                    },
                    pagination: {
                        labelRowsSelect: "",
                        labelDisplayedRows: "{count} de {from}-{to}",
                        firstTooltip: "Primeira página",
                        previousTooltip: "Página anterior",
                        nextTooltip: "Próxima página",
                        lastTooltip: "Última página",
                    },
                }}
            />
        </Container >
    );
}

MyTable.propTypes = {
    reload: PropTypes.bool,
    setData: PropTypes.func,
    setOpen: PropTypes.func,
    setReload: PropTypes.func,
    setAffiliates: PropTypes.func,
};
